import React from 'react';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import { Dropdown } from '@insurancemenu/imenu-components-lib';
import { DropdownPropsType } from '@insurancemenu/imenu-components-lib/dist/types';
import { ButtonStyled } from './styles';

export const TableActionsDropdown: React.FC<DropdownPropsType> = (props) => {
  return (
    <Dropdown
      {...props}
      closedElement={
        <ButtonStyled
          $isClosed
          color="primary"
          type="text"
          rightIconProp={<ChevronDown />}
          size="small"
          disabled={props.options.length === 0}
        >
          MORE
        </ButtonStyled>
      }
      openedElement={
        <ButtonStyled
          $isClosed={false}
          color="primary"
          rightIconProp={<ChevronUp />}
          size="small"
          disabled={props.options.length === 0}
        >
          MORE
        </ButtonStyled>
      }
    />
  );
};
